<vdw-planning-display #display class="full-height overflow-hidden" [class.onboarding-running]="planningContext.isOnboardingRunning">
  <vdw-planning-grid [startDate]="selectedDateRange[0]" [endDate]="selectedDateRange[1]" [rowTitle]="'MACHINE.MACHINE' | bmsTranslate: {count: 2}" (gridSelected)="onGridDisplaySelected($event)">
    <vdw-shift-schedule *ngFor="let regime of regimes" [days]="regime.days">
      <vdw-shift *ngFor="let shift of regime.shifts" [name]="getShiftName(shift, regime)" [start]="shift.shiftStart" [end]="shift.shiftEnd"></vdw-shift>
    </vdw-shift-schedule>

    <vdw-planning-row
      *ngFor="let machine of planningContext.machinesForSelectedPlanningGroups"
      [dataTransfer]="machine"
      [icon]="getMachineIcon(machine)"
      [color]="getMachineColor(machine)"
      [indicatorText]="getMachineName(machine)"
      [clickable]="!planningContext.isOnboardingRunning"
      [rowBackgroundColor]="getRowBackgroundColor(machine)"
      (selected)="planning.planningSideBars.openMachineDetails(machine)"
    >
      <vdw-planning-group
        vdwPlanningDragDrop
        class="planning-run"
        *ngFor="let machineRun of getRunsForMachineId(machine.id); trackBy: trackByRunId"
        [dataTransfer]="machineRun"
        [applyCustomBorder]="true"
        [endDate]="machineRun.endDate"
        [startDate]="machineRun.startDate"
        [groupText]="getRunTitle(machineRun)"
        [clickable]="!planningContext.isOnboardingRunning"
        [isItemDraggable]="planningContext.canEditPlanningItem(machineRun)"
        [class.incompatible]="!machineRun.compatibleWithMachine"
        [class.completed]="!isRunDemoItem(machineRun) && hasRunBeenCompleted(machineRun)"
        [class.past-due]="hasRunOrdersPastDueDate(machineRun)"
        (dragStart)="onPlanningItemDragStart($event)"
        (dragEnd)="dragDropChanges.planningItemDragEnd($event)"
        (dragMove)="dragDropChanges.planningRunDragEnter($event)"
        (selected)="planning.planningSideBars.openPlanningItemDetails(machine, machineRun)"
      >
        <ng-template
          *ngFor="let planningOrder of machineRun.planningOrders; let orderIndex = index; trackBy: trackByOrderId"
          vdwPlanningItem
          vdwPlanningDragDrop
          [dataTransfer]="planningOrder"
          [applyCustomBorder]="false"
          [endDate]="planningOrder.endDate"
          [startDate]="planningOrder.startDate"
          [clickable]="!planningContext.isOnboardingRunning"
          [isItemDraggable]="planningContext.canEditPlanningOrder(planningOrder)"
          [class]="getOrderClass(planningOrder)"
          [newGroupText]="getNewRunText()"
          (dragStart)="onPlanningOrderDragStart($event)"
          (dragMove)="dragDropChanges.planningOrderDragEnter($event)"
          (dragEnd)="dragDropChanges.onPlanningOrderDragEnd($event)"
          (selected)="planning.planningSideBars.openPlanningOrderDetails(planningOrder.id)"
        >
          <app-planning-order-card
            class="full-height flex-row"
            [class.cursor-pointer]="!planningContext.isOnboardingRunning"
            [class.cursor-grab]="planningContext.canEditPlanningOrder(planningOrder)"
            [planningOrder]="planningOrder"
            [machineRunTitle]="getRunTitle(machineRun)"
            [compatibleWithMachine]="machineRun.compatibleWithMachine"
            [shouldShowRightBorder]="shouldOrderShowRightBorder(machineRun, planningOrder, orderIndex)"
          ></app-planning-order-card>
        </ng-template>
      </vdw-planning-group>
      <ng-template
        *ngFor="let planningItem of getPlanningItemsForMachineId(machine.id); trackBy: trackByPlanningItemId"
        vdwPlanningItem
        vdwPlanningDragDrop
        class="maintenance"
        [dataTransfer]="planningItem"
        [applyCustomBorder]="true"
        [endDate]="planningItem.endDate"
        [startDate]="planningItem.startDate"
        [clickable]="!planningContext.isOnboardingRunning"
        [isItemDraggable]="planningContext.canEditPlanningItem(planningItem)"
        (dragStart)="onPlanningItemDragStart($event)"
        (dragEnd)="dragDropChanges.planningItemDragEnd($event)"
        (selected)="planning.planningSideBars.openPlanningItemDetails(machine, planningItem)"
      >
        <app-planning-inactivitiy-card [planningItem]="planningItem" [isCompleted]="isPlanningItemCompleted(planningItem)"></app-planning-inactivitiy-card>
      </ng-template>
    </vdw-planning-row>
  </vdw-planning-grid>
</vdw-planning-display>
